import script from "./ModalAcoesCurricularizadas.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalAcoesCurricularizadas.vue?vue&type=script&setup=true&lang=js"

import "./ModalAcoesCurricularizadas.vue?vue&type=style&index=0&id=197367d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-197367d7"]])

export default __exports__